var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeclinedFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 21 21",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.333 2.167a8.333 8.333 0 1 0 0 16.666 8.333 8.333 0 0 0 0-16.666ZM6.408 7.754 9.155 10.5l-2.746 2.746 1.178 1.179 2.746-2.746 2.746 2.746 1.179-1.179-2.746-2.746 2.746-2.746-1.178-1.179-2.747 2.747-2.746-2.747-1.179 1.179Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeclinedFilled);
export default __webpack_public_path__ + "static/media/declinedFilled.57130c3b6994bdf33993aefabbe9d014.svg";
export { ForwardRef as ReactComponent };